import { ComponentSample, Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  box: Item<'Box'>;
  box1: Item<'Box'>;
  box2: Item<'Box'>;
  box3: Item<'Box'>;
  typography: Item<'Typography'>;
  typography1: Item<'Typography'>;
  typography2: Item<'Typography'>;
  emptySpacer: Item<'EmptySpacer'>;
} = {
  emptySpacer: {
    children: [],
    itemId: 'emptySpacer',
    parent: 'box1',
    props: {},
    type: 'EmptySpacer',
  },
  box: {
    children: ['box1', 'box2', 'box3'],
    itemId: 'box',
    parent: 'flexItem',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.paper',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      borderRadius: '8px',
      boxShadow: '3',
      margin: {
        all: 20,
      },
      padding: {
        all: 4,
      },
    },
    type: 'Box',
  },
  box1: {
    children: ['typography'],
    itemId: 'box1',
    parent: 'box',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.default',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      boxHeight: '50px',
      boxWidth: '50px',
      margin: {
        all: 4,
      },
    },
    type: 'Box',
  },
  box2: {
    children: ['typography1'],
    itemId: 'box2',
    parent: 'box',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.default',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      boxHeight: '50px',
      boxWidth: '50px',
      margin: {
        all: 4,
      },
    },
    type: 'Box',
  },
  box3: {
    children: ['typography2'],
    itemId: 'box3',
    parent: 'box',
    props: {
      bgcolor: {
        type: 'text',
        value: 'background.default',
      },
      border: {
        all: {
          style: 'solid',
          width: 1,
        },
      },
      boxHeight: '50px',
      boxWidth: '50px',
      margin: {
        all: 4,
      },
    },
    type: 'Box',
  },
  flexItem: {
    children: ['box'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {},
    type: 'FlexPanel',
  },
  root: {
    children: ['flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
      padding: { all: 0 },
    },
    type: 'Page',
  },
  typography: {
    children: [],
    itemId: 'typography',
    parent: 'box1',
    props: {
      text: {
        type: 'text',
        value: 'A',
      },
    },
    type: 'Typography',
  },
  typography1: {
    children: [],
    itemId: 'typography1',
    parent: 'box2',
    props: {
      text: {
        type: 'text',
        value: 'B',
      },
    },
    type: 'Typography',
  },
  typography2: {
    children: [],
    itemId: 'typography2',
    parent: 'box3',
    props: {
      text: {
        type: 'text',
        value: 'C',
      },
    },
    type: 'Typography',
  },
};

export const helpRenders: ComponentSample<'Box'>[] = [
  {
    title: 'Plain Box',
    description: 'Try changing various Box properties to see how it renders',
    page,
    exampleId: 'eg-plain',
    clearParentChildren: true,
    height: 280,
    visibleProps: [
      'bgcolor',
      'borderRadius',
      'boxShadow',
      'margin',
      'padding',
      'border',
      'hoverBgcolor',
    ],
    item: {
      itemId: 'box',
      type: 'Box',
      children: ['emptySpacer'],
      parent: 'flexItem',
      props: {
        bgcolor: {
          type: 'text',
          value: 'background.paper',
        },
        hoverBgcolor: {
          type: 'text',
          value: 'primary.main',
        },
        borderRadius: '8px',
        boxShadow: '3',
        margin: {
          all: 20,
        },
        padding: {
          all: 40,
        },
        border: {
          all: {
            width: 1,
            style: 'solid',
          },
        },
      },
    },
  },
  {
    title: 'A Circle',
    description:
      'To make a circle out of a box, set the border radius to 50% and provide equal with & height for the box',
    page,
    exampleId: 'eg-borderRadius',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['borderRadius', 'boxWidth', 'boxHeight'],
    item: {
      itemId: 'box',
      type: 'Box',
      children: ['emptySpacer'],
      parent: 'flexItem',
      props: {
        bgcolor: {
          type: 'text',
          value: 'primary.main',
        },
        borderRadius: '50%',
        hoverBgcolor: {
          type: 'text',
          value: 'primary.main',
        },
        boxWidth: '100px',
        boxHeight: '100px',
      },
    },
  },
  {
    title: 'Flex Direction',
    description: `Use Flex Direction to change the direction of the child components.

Refer: [https://developer.mozilla.org/en-US/docs/Glossary/Main_Axis ](https://developer.mozilla.org/en-US/docs/Glossary/Main_Axis)`,
    page,
    exampleId: 'eg-01FXRPXNV1MNXR2M3NA110P04N',
    clearParentChildren: true,
    height: 334,
    visibleProps: ['flexDirection'],
    item: {
      itemId: 'box',
      type: 'Box',
      children: ['box1', 'box2', 'box3'],
      parent: 'flexItem',
      props: {
        flexDirection: 'column',
        bgcolor: {
          type: 'text',
          value: 'background.paper',
        },
        border: {
          all: {
            width: 1,
            style: 'solid',
          },
        },
        padding: {
          all: 4,
        },
        boxHeight: '334px',
      },
    },
  },
  {
    title: 'Align Items',
    description: `Use Align Items to change the alignment of the child components. Check how it aligns with different direction i.e. column vs row.

Refer: [https://developer.mozilla.org/en-US/docs/Web/CSS/align-items](https://developer.mozilla.org/en-US/docs/Web/CSS/align-items)`,
    page,
    exampleId: 'eg-alignItems',
    clearParentChildren: true,
    height: 334,
    visibleProps: ['flexDirection', 'alignItems'],
    item: {
      itemId: 'box',
      type: 'Box',
      children: ['box1', 'box2', 'box3'],
      parent: 'flexItem',
      props: {
        flexDirection: 'column',
        alignItems: 'flex-end',
        bgcolor: {
          type: 'text',
          value: 'background.paper',
        },
        border: {
          all: {
            width: 1,
            style: 'solid',
          },
        },
        padding: {
          all: 4,
        },
        boxHeight: '334px',
      },
    },
  },
  {
    title: 'Justify Content',
    description: `Use Justify Content to change the space between and around the child components along the main axis. Check how it distributes with different direction i.e. column vs row. 

Refer: [https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content](https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content)`,
    page,
    exampleId: 'eg-justifyContent',
    clearParentChildren: true,
    height: 334,
    visibleProps: ['flexDirection', 'justifyContent'],
    item: {
      itemId: 'box',
      type: 'Box',
      children: ['box1', 'box2', 'box3'],
      parent: 'flexItem',
      props: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        bgcolor: {
          type: 'text',
          value: 'background.paper',
        },
        border: {
          all: {
            width: 1,
            style: 'solid',
          },
        },
        padding: {
          all: 4,
        },
        boxHeight: '334px',
      },
    },
  },
  {
    title: 'Rendering Image or SVG',
    description:
      'You can use the Src prop to render any Image or SVG with Component prop set to Image',
    page,
    exampleId: 'eg-svg',
    clearParentChildren: true,
    height: 280,
    visibleProps: ['component', 'src'],
    item: {
      itemId: 'box',
      type: 'Box',
      children: [],
      parent: 'flexItem',
      props: {
        bgcolor: {
          type: 'text',
          value: 'background.paper',
        },
        margin: {
          all: 20,
        },
        border: {
          all: {
            width: 0,
            style: 'solid',
          },
        },
        padding: {
          all: 4,
        },
        component: 'img',
        src: {
          type: 'text',
          value:
            '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_3927_8340)"> <path d="M12 20H10.922L10.6211 19.9999C7.67346 19.9999 4.72607 19.9999 1.77898 19.9999C1.05383 19.9999 0.482168 19.7227 0.171638 19.0168C0.0648319 18.7643 0.00983267 18.491 0.0101981 18.2148C0.000199962 14.0756 -0.0024466 9.93449 0.0022584 5.79156C0.0022584 4.70039 0.689482 4.00189 1.74458 4.00004C4.69932 4.00004 7.65405 4.00004 10.6088 4.00004H10.9017L12 4V20Z" fill="#757575"/> <path d="M11 19.9889V18.8573H21.7769C21.9082 18.8598 22.0395 18.8521 22.1693 18.8342C22.2969 18.8211 22.4159 18.7708 22.5072 18.6915C22.5985 18.6121 22.657 18.5082 22.6733 18.3963C22.6915 18.2899 22.7003 18.1824 22.6996 18.0748C22.6996 14.0262 22.6996 9.97752 22.6996 5.92887C22.6996 5.32656 22.4892 5.1418 21.8063 5.1418H11.0084V4H11.2883C14.8199 4 18.3526 4 21.8863 4C23.1993 4 23.9989 4.70023 24 5.85404C24 9.95627 24 14.0588 24 18.1617C24 19.26 23.212 19.9917 21.9957 19.9945C18.3841 20.0018 14.7719 20.0018 11.1589 19.9945C11.1168 19.9972 11.0736 19.9926 11 19.9889Z" fill="#757575"/> <path d="M5.442 9.15002H6.506L8.706 14.862H7.634L7.098 13.35H4.818L4.282 14.862H3.25L5.442 9.15002ZM5.09 12.59H6.834L5.978 10.134H5.954L5.09 12.59Z" fill="white"/> <path d="M16.1299 11.542H17.7619C18.0019 11.542 18.2019 11.4754 18.3619 11.342C18.5219 11.2034 18.6019 11.006 18.6019 10.75C18.6019 10.462 18.5299 10.2594 18.3859 10.142C18.2419 10.0247 18.0339 9.96602 17.7619 9.96602H16.1299V11.542ZM15.1299 9.15002H17.9059C18.4179 9.15002 18.8286 9.26736 19.1379 9.50202C19.4472 9.73669 19.6019 10.0914 19.6019 10.566C19.6019 10.854 19.5299 11.102 19.3859 11.31C19.2472 11.5127 19.0472 11.67 18.7859 11.782V11.798C19.1379 11.8727 19.4046 12.0407 19.5859 12.302C19.7672 12.558 19.8579 12.8807 19.8579 13.27C19.8579 13.494 19.8179 13.7047 19.7379 13.902C19.6579 14.094 19.5325 14.262 19.3619 14.406C19.1912 14.5447 18.9725 14.6567 18.7059 14.742C18.4392 14.822 18.1219 14.862 17.7539 14.862H15.1299V9.15002ZM16.1299 14.046H17.8979C18.2019 14.046 18.4365 13.9687 18.6019 13.814C18.7725 13.654 18.8579 13.43 18.8579 13.142C18.8579 12.8594 18.7725 12.6434 18.6019 12.494C18.4365 12.3394 18.2019 12.262 17.8979 12.262H16.1299V14.046Z" fill="#757575"/> </g> <defs> <clipPath id="clip0_3927_8340"> <rect width="24" height="24" fill="white"/> </clipPath> </defs> </svg>',
        },
      },
    },
  },
];
